import { IRemark } from "libraries/service/resources/booking/interfaces/IGetBookings";

export interface INotepadState {
    xId: string;
    state: 'initial' | 'edit';
}

export interface IRemarkForNotepad extends IRemark{
    authorId?: number;
    /** Author's name. */
    name?: string;
}

export interface INotepadCustomStyle {
    width?: string;
    backgroundColorOdd?: string;
    backgroundColorEven?: string;
}

export enum EEditState {
    initial = 'initial',
    edit = 'edit'
}

export enum ENoteFormProp {
    noteXId = 'noteXId',
    noteText = 'noteText',
    noteWhenLastUpdated = 'noteWhenLastUpdated',
    noteWhoLastUpdated = 'noteWhoLastUpdated',
    noteAuthorId = 'noteAuthorId',
    noteAuthorName = 'noteAuthorName',
    isNew = 'isNew',
    editState = 'editState',
    key = 'key',
}

export interface INoteFormValue {
    [ENoteFormProp.noteXId]: string;
    [ENoteFormProp.key]: string;
    [ENoteFormProp.noteText]: string;
    [ENoteFormProp.noteWhenLastUpdated]: string;
    [ENoteFormProp.noteWhoLastUpdated]: string;
    [ENoteFormProp.noteAuthorId]: number;
    [ENoteFormProp.noteAuthorName]: string;
    [ENoteFormProp.isNew]: boolean;
    [ENoteFormProp.editState]: EEditState;
}
